import Vue from 'vue' // 移除
import App from './App.vue'
import router from './router' // 移除
import store from './store'
import APi from './router/APi.vue'
// 配置antd
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Print from 'vue-print-nb' // 注册打印机
// 注册PDF
import htmlToPdf from '../src/components/htmlToPdf'
// 配置ui
import ElementUI from 'element-ui' // 移除
import 'element-ui/lib/theme-chalk/index.css' // 移除
import vueLoading from 'vue-loading-template'
Vue.use(vueLoading)
Vue.use(htmlToPdf)
Vue.use(Print)
Vue.use(ElementUI) // 移除
Vue.use(Antd)
// import 'lib-flexible'
Vue.config.productionTip = false
Vue.prototype.APi = APi.serverSrc // 公共url
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
